// import React from "react";
// import { Modal, Button } from "react-bootstrap";
// import { motion } from "framer-motion";
// import { FiAlertCircle, FiX } from "react-icons/fi";

// const AlertModal = ({
//   show,
//   onHide,
//   title,
//   message,
//   variant = "danger",
//   size = "md",
//   showConfirmButton = true,
//   confirmText = "OK",
// }) => {
//   const variantColors = {
//     danger: {
//       bg: "bg-danger-subtle",
//       text: "text-danger",
//       button: "btn-danger",
//       icon: <FiAlertCircle className="text-danger" size={24} />,
//     },
//     warning: {
//       bg: "bg-warning-subtle",
//       text: "text-warning",
//       button: "btn-warning",
//       icon: <FiAlertCircle className="text-warning" size={24} />,
//     },
//     info: {
//       bg: "bg-info-subtle",
//       text: "text-info",
//       button: "btn-info",
//       icon: <FiAlertCircle className="text-info" size={24} />,
//     },
//     success: {
//       bg: "bg-success-subtle",
//       text: "text-success",
//       button: "btn-success",
//       icon: <FiAlertCircle className="text-success" size={24} />,
//     },
//   };

//   const colors = variantColors[variant] || variantColors.danger;

//   return (
//     <Modal show={show} onHide={onHide} centered size={size} backdrop="static">
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.25 }}
//       >
//         <Modal.Header
//           className={`${colors.bg} border-0 position-relative`}
//           closeButton={false}
//         >
//           <div className="d-flex align-items-center gap-2">
//             {colors.icon}
//             <Modal.Title className={`${colors.text} mb-0`}>{title}</Modal.Title>
//           </div>
//           <button
//             onClick={onHide}
//             className="btn btn-sm position-absolute end-0 top-0 m-2"
//           >
//             <FiX size={20} />
//           </button>
//         </Modal.Header>

//         <Modal.Body className="py-4">
//           <p className="mb-0">{message}</p>
//         </Modal.Body>

//         {showConfirmButton && (
//           <Modal.Footer className="border-0">
//             <div className="w-100 d-flex justify-content-end">
//               <motion.div
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//               >
//                 <Button
//                   variant={variant}
//                   onClick={onHide}
//                   className={colors.button}
//                 >
//                   {confirmText}
//                 </Button>
//               </motion.div>
//             </div>
//           </Modal.Footer>
//         )}
//       </motion.div>
//     </Modal>
//   );
// };

// export default AlertModal;
import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FiAlertCircle, FiX } from "react-icons/fi";

const AlertModal = ({
  show,
  onHide,
  title,
  message,
  variant = "danger",
  size = "md",
  showConfirmButton = true,
  confirmText = "OK",
}) => {
  const variantColors = {
    danger: {
      bg: "bg-danger-subtle",
      text: "text-danger",
      button: "btn-danger",
      icon: <FiAlertCircle className="text-danger" size={24} />,
    },
    warning: {
      bg: "bg-warning-subtle",
      text: "text-warning",
      button: "btn-warning",
      icon: <FiAlertCircle className="text-warning" size={24} />,
    },
    info: {
      bg: "bg-info-subtle",
      text: "text-info",
      button: "btn-info",
      icon: <FiAlertCircle className="text-info" size={24} />,
    },
    success: {
      bg: "bg-success-subtle",
      text: "text-success",
      button: "btn-success",
      icon: <FiAlertCircle className="text-success" size={24} />,
    },
  };

  const colors = variantColors[variant] || variantColors.danger;

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [show, onHide]);

  return (
    <Modal show={show} onHide={onHide} top size={size} backdrop="static">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
      >
        <Modal.Header
          className={`${colors.bg} border-0 position-relative`}
          closeButton={false}
        >
          <div className="d-flex align-items-center gap-2">
            {colors.icon}
            <Modal.Title className={`${colors.text} mb-0`}>{title}</Modal.Title>
          </div>
          <button
            onClick={onHide}
            className="btn btn-sm position-absolute end-0 top-0 m-2"
          >
            <FiX size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="py-4">
          <p className="mb-0">{message}</p>
        </Modal.Body>

        {showConfirmButton && (
          <Modal.Footer className="border-0">
            <div className="w-100 d-flex justify-content-end">
              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Button
                  variant={variant}
                  onClick={onHide}
                  className={colors.button}
                >
                  {confirmText}
                </Button>
              </motion.div>
            </div>
          </Modal.Footer>
        )}
      </motion.div>
    </Modal>
  );
};

export default AlertModal;
